import React from "react";
import { getMgmtRunning } from "../../../models/management";
import i18n from "../../../i18n";
import { MzadLoader } from "../../helpers/mzadLoader";
import { Modal } from "react-bootstrap";
import ListAucsTable from "./list_aucs";
import { getAllBidders, getAuctions } from "../../../models/auctions";
import { SaudiRiyalLogo } from "../../logo/saudiLogo";

export class DashboardRunning extends React.Component {
  constructor() {
    super();
    this.state = {
      is_loading: false,
      auctions: [],
      groups: [],
      selected_group: {},
      group_total: 0,
      open_bidder_popup: false,
      bidders: [],
    };
    this.getTodaysList = this.getTodaysList.bind(this);
    this.openBiddersPopup = this.openBiddersPopup.bind(this);
  }
  componentDidMount() {
    this.getTodaysList();
  }

  async openBiddersPopup(item) {
    this.setState({ bidders: {}, bidder_loader: true });
    const response = await getAllBidders({ group: item?.id });
    let bidders = response.data;
    if (bidders && bidders.length > 0) {
      this.setState({ open_bidder_popup: true, bidders, bidder_loader: false });
    }
  }

  async getTodaysList() {
    this.setState({ is_loading: true });
    let q = "";
    let { input } = this.props;
    if (input.stat_type) {
      q += "&stat_type=" + input.stat_type;
    }
    if (input && typeof input.s_fdate !== "undefined") {
      q += "&s_fdate=" + input.s_fdate;
    }
    if (input && typeof input.s_tdate !== "undefined") {
      q += "&s_tdate=" + input.s_tdate;
    }
    const response = await getMgmtRunning(q);
    if (response.success) {
      this.setState({ is_loading: false, groups: response?.data });
    } else {
      this.setState({ is_loading: false });
    }
  }

  async loadAllAuctions(params, isFundPopup = false) {
    this.setState({ is_loading_aucs: true, auctions: [] });
    const response = await getAuctions("?is_client=1&" + params);
    if (response) {
      let auctions = response.data;
      let meta = response.meta;
      this.setState({
        auctions: auctions,
        is_loading_aucs: false,
        group_info: meta?.group || {},
      });
      this.setState({
        group_total: meta.totalAmount,
        pm_entries: meta.pm_entries,
      });
    }
  }

  openApprove(group, is_group = false) {
    this.setState({
      open_approve_popup: true,
      selected_id: group.id,
      selectedRows: [],
      selected_group: group,
    });
    this.loadAllAuctions(`group=${group.id}`);
  }

  render() {
    let { groups, auctions, is_loading, selected_group, group_total } =
      this.state;
    return (
      <React.Fragment>
        <MzadLoader loading={is_loading} />
        {!is_loading && (
          <table className="table table-bordered table-hover table-striped">
            <thead class="thead-dark">
              <tr>
                <th>{i18n.t("sl_no")}</th>
                <th>{i18n.t("client_name")}</th>
                <th>{i18n.t("group_name")}</th>
                <th>{i18n.t("total_auctions")}</th>
                <th>{i18n.t("total_bidders")}</th>
              </tr>
            </thead>
            <tbody>
              {groups.length > 0 &&
                groups.map((item, i) => {
                  return (
                    <tr>
                      <td>{i + 1}</td>
                      <td>{item?.organization_info?.organization_name}</td>
                      <td>{item?.group_name}</td>
                      <td>
                        <button
                          className="btn btn-info rounded-5 py-1 px-2"
                          style={{
                            textWrap: "nowrap",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            this.openApprove(item);
                          }}
                        >
                          {item?.total_auctons}
                        </button>
                      </td>
                      <td>
                        <button
                          className="btn btn-warning rounded-5 py-1 px-2"
                          style={{
                            textWrap: "nowrap",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            this.openBiddersPopup(item);
                          }}
                        >
                          {item?.total_enrolled}
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        )}

        <Modal
          show={this.state.open_approve_popup}
          onHide={() => this.setState({ open_approve_popup: false })}
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title
              id="example-modal-sizes-title-lg"
              style={{ width: "95%" }}
            >
              <div className="d-flex justify-content-between">
                <div style={{ fontSize: "1rem" }}>
                  {selected_group?.organization_info?.organization_name} (
                  {!this.state.is_loading_aucs && (
                    <>
                      {i18n.t("total_auctions")}: {auctions.length}
                    </>
                  )}
                  )
                </div>
                {!this.state.is_loading_aucs && (
                  <div className="px-4" style={{ fontSize: "1rem" }}>
                    {i18n.t("total_amount")} {group_total.toFixed(2)}
                  </div>
                )}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader loading={this.state.is_loading_aucs} />
            {!this.state.is_loading_aucs && auctions.length > 0 && (
              <ListAucsTable
                auctions={auctions}
                group={selected_group}
                group_info={this.state.group_info}
              />
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.open_bidder_popup}
          onHide={() => this.setState({ open_bidder_popup: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {i18n.t("bidders")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <MzadLoader loading={this.state.bidder_loader} />
            {this.state.bidders && this.state.bidders.length > 0 && (
              <table className="table table-stripped">
                <thead>
                  <tr>
                    <th>
                      {i18n.t("name")} & {i18n.t("details")}
                    </th>
                    <th>{i18n.t("amount")}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.bidders.map((item, i) => {
                    return (
                      <>
                        <tr>
                          <td>
                            {item.name}(
                            <small className="text text-dark">
                              USER ID : {item.user_id}
                            </small>
                            )<br />
                            <small className="text text-dark">
                              {i18n.t("bidder_id")} : {item.id}
                            </small>
                            <span>
                              {item.email && (
                                <>
                                  <br />
                                  <small className="text text-dark">
                                    {item.email}
                                  </small>
                                </>
                              )}
                              {item.mobile && (
                                <>
                                  <br />
                                  <small className="text text-dark">
                                    {item.mobile}
                                  </small>
                                </>
                              )}
                            </span>
                            <span>
                              <br />
                              <small className="text text-dark">
                                {i18n.t("auction")} : {item.title}
                              </small>
                            </span>
                          </td>
                          <td>
                           <SaudiRiyalLogo/>&nbsp;{item.bid_amount}
                          </td>
                        </tr>
                        <hr />
                      </>
                    );
                  })}
                </tbody>
              </table>
            )}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}
